import {
  AdaptedProduct,
  AdapterResponse,
  Categories,
  CCList,
  Data,
  Pagination,
  ParsedPagination,
  Product,
  SubcategoryArray,
} from '../../collaborators/fetch-products/new-contract/types';
import facetAdapter from './facet';
import productAdapter from './product';

const originalValueIsValid = (originalValue: string): boolean =>
  !!originalValue;

const getSubcategoryDefaultValueIfEmpty = (originalValue: string): string =>
  originalValue || '';

const getDefaultValueIfEmpty = (originalValue: string): number =>
  originalValueIsValid(originalValue) ? Number(originalValue) : 0;

const ccProductIdList = (
  cc: CCList,
  ccListProductsArray: Record<string, Array<string>>
) => {
  return ccListProductsArray[cc.styleId]
    ? ccListProductsArray[cc.styleId].push(cc.ccId)
    : (ccListProductsArray[cc.styleId] = [cc.ccId]);
};

const composeSubcatProductList = (
  adaptedProducts: AdaptedProduct[],
  ccListProductsArray: Record<string, Array<string>>,
  subCatProducts: AdaptedProduct[],
  styleId: string
) => {
  const productsFound = adaptedProducts.find(
    (product) => product.productID === styleId
  );
  if (productsFound) {
    productsFound.swatchesProps = productsFound.swatchesProps?.filter(
      (swatch) => {
        return ccListProductsArray[styleId].includes(swatch.id);
      }
    );
    subCatProducts.push(productsFound);
  }
};

const getSubcatProducts = (
  ccList: CCList[],
  products: Product[]
): AdaptedProduct[] => {
  const subCatProducts: AdaptedProduct[] = [];
  const adaptedProducts: AdaptedProduct[] = products.map(productAdapter);
  const ccListProductsArray: Record<string, Array<string>> = {};
  ccList?.forEach((cc) => ccProductIdList(cc, ccListProductsArray));
  const ccListIdKeys = Object.keys(ccListProductsArray);
  ccListIdKeys.forEach((styleId) =>
    composeSubcatProductList(
      adaptedProducts,
      ccListProductsArray,
      subCatProducts,
      styleId
    )
  );

  return subCatProducts;
};

const composeSubcategory = (
  category: Categories,
  products: Product[]
): SubcategoryArray => {
  const name = category.subCategoryName ?? category.categoryName;
  const id = category.subCategoryId ?? category.categoryId;
  return {
    heading: getSubcategoryDefaultValueIfEmpty(name),
    cid: getSubcategoryDefaultValueIfEmpty(id),
    products: getSubcatProducts(category.ccList, products),
  };
};

const parsePagination = (pagination: Pagination): ParsedPagination => {
  return {
    pageNumberRequested: getDefaultValueIfEmpty(pagination.currentPage),
    pageNumberTotal: getDefaultValueIfEmpty(pagination.pageNumberTotal),
    pageSize: Number(pagination.pageSize || 300),
  };
};

const newContractAdapter = (data: Data): AdapterResponse => {
  const categories = data.categories;
  const composedSubcategory = categories
    .map((category) => composeSubcategory(category, data.products))
    .filter(Boolean);

  return {
    gridData: composedSubcategory,
    paginator: parsePagination(data.pagination),
    facetData: facetAdapter(data.facets),
    totalItemCount: getDefaultValueIfEmpty(data.totalColors),
  };
};

export default newContractAdapter;
